module.exports = __webpack_public_path__ + "assets/fonts/opensans-regular_180475e.ttf";